import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
export interface IPsnAlertStateSlice {
  psnAlertFilters: IPsnAlertFilterState;
}

const name = "psnAlert";

export const initialState: IPsnAlertStateSlice = {
  psnAlertFilters: {
    consent: ["1", "2"],
    respRate: "24h",
    levels: ["Acute, Level 2", "Acute, Level 3", "Acute", "Level 2", "Level 3"],
    date: 1,
    customDate: null,
  },
};

export const psnAlertSlice = createSlice({
  name,
  initialState,
  reducers: {
    setPsnAlertFilters(
      state,
      action: PayloadAction<Partial<IPsnAlertFilterState>>
    ) {
      state.psnAlertFilters = {
        ...state.psnAlertFilters,
        ...action.payload,
      };
    },
  },
});

export const { setPsnAlertFilters } = psnAlertSlice.actions;

const persistedReducer = persistReducer(
  { key: name, storage: storage, whitelist: [] },
  psnAlertSlice.reducer
);

export default persistedReducer;
